export default "__VITE_ASSET__BgAiGzFR__"